<script>
  // import bus from '../../utils/events/bus'

  export default {
    name: 'form-save-button',
    props: ['eventClick', 'isDisabled', 'isSubmitted'],
    methods: {
      onSend () {
        // bus.$emit('show-loader')
        this.eventClick()
      }
    }
  }
</script>

<template>
    <el-button type="primary"
               @click="onSend"
               :disabled="isDisabled"
               :loading="isSubmitted">
        {{isSubmitted ? 'Salvando' : 'Salvar'}} Alterações
    </el-button>
</template>



// WEBPACK FOOTER //
// SaveButton.vue?786dffc3